export default __webpack_public_path__ + "static/social-banner-5affa1cd4a66c135d88c9cd73a7be4fd.png";